import React from 'react';
import HomeBanner from './HomeBanner';
import HomePanelLaunchers from './HomePanelLaunchers';
import HomePanelCustomContent from './HomePanelCustomContent';

const HomePanelNarrow = () => (
  <div className="aridhia-home-panel-narrow">
    <HomeBanner compact />
    <HomePanelLaunchers compact />
    <HomePanelCustomContent compact />
  </div>
);

export default HomePanelNarrow;
